import moment from "moment";
import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleButton from "../../../../modules/commons/SimpleButton";

class MasterHargaJasaSearch extends Component {
  constructor(props) {
    super(props);
    this.initialDate = moment().format("DD-MM-YYYY");
    this.state = {
      dataCabang: [],
      selectedCabang: null,
      loading: false
    };
  }

  render() {
    const {
      startTanggalBerlaku,
      endTanggalBerlaku,
      onPeriodeChange,
      onSearch,
      handleFilterVisibility,
    } = this.props;

    return (
      <FlexView
        vAlignContent="center"
        marginBottom="15px"
        style={{ justifyContent: "space-between" }}
      >
        <FlexView vAlignContent="center" style={{ gap: "10px" }}>
          <p className="margin margin-bottom-15px">Periode</p>
          <SimpleDate
            id="data_picker_start_date"
            name="startTanggalBerlaku"
            nextdate
            date={startTanggalBerlaku}
            onChange={(value) => onPeriodeChange("startTanggalBerlaku", value)}
          />
          <p className="margin margin-bottom-15px">s/d</p>
          <SimpleDate
            id="data_picker_start_date"
            name="endTanggalBerlaku"
            backdate
            date={endTanggalBerlaku}
            minDate={startTanggalBerlaku}
            onChange={(value) => onPeriodeChange("endTanggalBerlaku", value)}
          />
          <SimpleButton
            text="Cari"
            className="margin-bottom-15px"
            onClick={()=> {
              onSearch({
                startTanggalBerlaku: startTanggalBerlaku,
                endTanggalBerlaku: endTanggalBerlaku
              })
            }}
          />
        </FlexView>
        <SimpleButton
          category="action_button"
          onClick={() => handleFilterVisibility()}
          className="btn background-red margin-bottom-15px"
          icon={
            <span>
              <i className="fa fa-qrcode"></i>
            </span>
          }
        />
      </FlexView>
    );
  }
}

export default MasterHargaJasaSearch;
